import { InputProps } from "./Form.Interface";
import React from "react";

const Forms: { [x: string]: InputProps[] } =
{
    region_master: [
        {
            type: "text",
            name: "region_name",
            label: "Region name",
            placeholder: "Region name",
            value: "",
            page_title: "Region Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Region name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "region_short_name",
            label: "Region short name",
            placeholder: "Region short name",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "required",
                    message: "Region short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "region_description",
            label: "Region description",
            placeholder: "Region description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
    ],
    hull_type_master: [
        {
            type: "text",
            name: "hull_type_name",
            label: "Hull type name",
            placeholder: "Hull type name",
            value: "",
            page_title: "Hull Type Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Hull name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"

                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "hull_description",
            label: "Hull description",
            placeholder: "Hull description",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
    ],
    direction_master: [
        {
            type: "text",
            name: "direction_name",
            label: "Direction name",
            placeholder: "Direction name",
            value: "",
            page_title: "Direction Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Direction name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"

                }
            ],

        },
        {
            type: "text",
            name: "direction_short_name",
            label: "Direction short name",
            placeholder: "Direction short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Direction short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],

        },
    ],
    beaufort_scale_master: [
        {
            type: "text",
            name: "beaufort_scale",
            label: "Beaufort scale",
            placeholder: "Beaufort scale",
            value: "",
            page_title: "Beaufort Scale Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Beaufort scale is required"
                },
                {
                    type: "matches",
                    value: /^([0-9]|1[012])$/,
                    message: "Please enter values between 0 - 12 only"

                }
            ],
        },
        {
            type: "text",
            name: "minimum_wind_speed",
            label: "Minimum wind speed",
            placeholder: "Minimum wind speed",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "required",
                    message: "Minimum wind speed is required"
                },
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "maximum_wind_speed",
            label: "Maximum wind speed",
            placeholder: "Maximum wind speed",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "required",
                    message: "Maximum wind speed is required"
                },
                {
                    type: "matches",
                    value: /^(\d{1,2}|1\d{2}|20\d|21[0-9]|22[0-0])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "select",
            name: "weather_condition",
            label: "Select weather condition",
            value: "",
            options: [
                { desc: "Fair Weather", value: "Fair Weather" },
                { desc: "Bad Weather", value: "Bad Weather" },
            ],
            validations: [],
        },
    ],

    contact_type_master: [
        {
            type: "text",
            name: "contact_type_name",
            label: "Contact type name",
            placeholder: "Contact type name",
            value: "",
            page_title: "Contact Type Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Contact type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],

        },
        {
            type: "text",
            name: "contact_type_short_name",
            label: "Contact type short name",
            placeholder: "Contact type short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Contact type short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],

        },
    ],
    port_master: [
        {
            type: "text",
            name: "port_name",
            label: "Port name",
            placeholder: "Port name",
            value: "",
            page_title: "Port Master",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "required",
                    message: "Port name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "port_short_name",
            label: "Port short name",
            placeholder: "Port short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Port short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],

        },
        {
            type: "text",
            name: "port_code",
            label: "Port code",
            placeholder: "Port code",
            table_columns: true,
            table_columns_sequence: 3,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Port code is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z0-9]{1,10}$/,
                    message: "Please enter block letters/numbers only"
                }
            ],

        },
        {
            type: "dynamic-select",
            name: "country_name",
            placeholder: "Select country ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "country",
            path: "country_master",
            validations: []
        },
        {
            type: "text",
            name: "lo_code",
            label: "LoCode",
            placeholder: "LoCode",
            table_columns: false,
            value: "",
            validations: [],
            disabled: true,
        },
        {
            type: "checkbox",
            name: "port_of_registry",
            typeValue: "boolean",
            label: "Port of registry?",
            defaultChecked: null,
            class: 'w-7',
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether Port of registry or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "is_eu_port",
            typeValue: "boolean",
            label: "EU port?",
            defaultChecked: null,
            checked: false,
            class: 'w-7',
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether EU port or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "Is_this_eca_port",
            typeValue: "boolean",
            label: "ECA port?",
            defaultChecked: null,
            class: 'w-7',
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether ECA port or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "Is_this_uk_port",
            typeValue: "boolean",
            label: "UK port?",
            defaultChecked: null,
            class: 'w-7',
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether UK port or not"
                }
            ]
        },
        {
            type: "textarea",
            id: "textarea",
            name: "port_description",
            label: "Port description",
            placeholder: "Port description",
            table_columns: false,
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],

        },

    ],
    country_master: [
        {
            type: "text",
            name: "country_name",
            placeholder: "Country name",
            page_title: "Country Master",
            label: "Country name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Country name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "country_iso_code2",
            placeholder: "Country ISO code2",
            label: "Country ISO code2",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Country ISO code2 is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2}$/,
                    message: "Please enter 2 block letters only"
                }
            ],
        },
        {
            type: "text",
            name: "country_iso_code3",
            placeholder: "Country ISO code3",
            label: "Country ISO code3",
            table_columns: true,
            table_columns_sequence: 3,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Country ISO code3 is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{3}$/,
                    message: "Please enter 3 block letters only"
                }
            ],
        },
        {
            type: "text",
            name: "country_code",
            placeholder: "Country calling code",
            label: "Country calling code",
            table_columns: false,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Country calling code is required"
                },
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "mid_number",
            placeholder: "Maritime identification digits",
            label: "Maritime identification digits",
            table_columns: false,
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "region_name",
            placeholder: "Select region ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "region_name",
            path: "region_master",
            validations: []
        },
        {
            type: "checkbox",
            name: "is_this_an_eu_country",
            typeValue: "boolean",
            label: "Is this an EU country?",
            defaultChecked: null,
            class: 'w-7',
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether EU country or not"
                }
            ]
        },
        {
            type: "file",
            value: '',
            name: "image",
            label: "Upload Flag Image",
            placeholder: "Upload Flag Image",
            validations: [],
            class: 'mb-3',
        },
    ],
    vessel_load_condition_master: [
        {
            type: "text",
            name: "load_condition_name",
            placeholder: "Load condition name",
            page_title: "Vessel Load Condition Master",
            label: "Load condition name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Load condition name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "load_condition_short_name",
            placeholder: "Load condition short name",
            label: "Load condition short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Load condition short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
    ],
    wind_direction_master: [
        {
            type: 'label',
            value: "",
            placeholder: "The value should be between 0 - 360",
            validations: [],
        },
        {
            type: "text",
            name: "wind_direction_degree",
            placeholder: "Wind direction degree",
            page_title: "Wind Direction Master",
            label: "Wind direction degree",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Wind direction degree is required"
                },
                {
                    type: "matches",
                    value: /^(?:36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])?$/,
                    message: "Value should be between 0 - 360"
                }
            ],
        },
    ],
    vessel_type_master: [
        {
            type: "text",
            name: "vessel_type_name",
            placeholder: "Vessel type name",
            page_title: "Vessel Type Master",
            label: "Vessel type name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "vessel_type_short_name",
            placeholder: "Vessel type short name",
            label: "Vessel type short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel type short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "vessel_type_description",
            placeholder: "Vessel type description",
            label: "Vessel type description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    vessel_sub_type_master: [
        {
            type: "text",
            name: "vessel_sub_type_name",
            placeholder: "Vessel sub type name",
            page_title: "Vessel Sub Type Master",
            label: "Vessel sub type name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel sub type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "vessel_sub_type_short_name",
            placeholder: "Vessel sub type short name",
            label: "Vessel sub type short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel sub type short name  is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "vessel_type_name",
            placeholder: "Select vessel type ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_type",
            path: "vessel_type_master",
            validations: []
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "vessel_type",
            label: "Vessel type name",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            options: [],
            validations: []
        },
        {
            type: "textarea",
            id: "textarea",
            name: "vessel_sub_type_description",
            placeholder: "Vessel sub type description",
            label: "Vessel sub type description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    fuel_type_master: [
        {
            type: "text",
            name: "fuel_type_name",
            placeholder: "Fuel type name",
            page_title: "Fuel Type Master",
            label: "Fuel type name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Fuel type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "fuel_type_short_name",
            placeholder: "Fuel type short name",
            label: "Fuel type short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Fuel type short name  is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "fuel_type_description",
            placeholder: "Fuel type description",
            label: "Fuel type description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    fuel_master: [
        {
            type: "text",
            name: "fuel_name",
            placeholder: "Fuel name",
            page_title: "Fuel Master",
            label: "Fuel name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Fuel name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "fuel_short_name",
            placeholder: "Fuel short name",
            label: "Fuel short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Fuel short name  is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "fuel_type_name",
            placeholder: "Select fuel type ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "fuel_type",
            path: "fuel_type_master",
            validations: [
                {
                    type: "required",
                    message: "Fuel type name is required"
                }
            ]
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "fuel_type",
            label: "Fuel type name",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            options: [],
            validations: []
        },
        {
            type: "text-unit",
            name: "max_sulphur_percentage",
            placeholder: "Max sulphur percentage",
            label: "Max sulphur percentage",
            table_columns: true,
            table_columns_sequence: 4,
            value: "",
            unit: "%",
            validations: [
                {
                    type: "required",
                    message: "Sulphur percentage  is required"
                },
                {
                    type: "matches",
                    value: /^100$|^100.00$|^\d{0,2}(\.\d{1,2})*$/,
                    message: "Please enter value between 0 - 100 only"
                }
            ],
        },
        {
            type: "text",
            name: "co2_emission",
            placeholder: "CO2 emmission",
            label: "CO2 emmission",
            table_columns: false,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "CO2 emmission  is required"
                },
                {
                    type: "matches",
                    value: /^\d*\.?\d*$/,
                    message: "Please enter upto 50 numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "density_at_temp",
            placeholder: "Density temperature",
            label: "Density temperature",
            table_columns: false,
            unit: [<sup>o</sup>, 'C'],
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Density at temperature  is required"
                },
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
        {
            type: "checkbox",
            name: "is_conventional_fuel",
            typeValue: "boolean",
            label: "Conventional fuel",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: []
        },
        {
            type: "checkbox",
            name: "is_eca_fuel",
            typeValue: "boolean",
            defaultChecked: null,
            label: "Is this ECA fuel",
            on: "Yes",
            off: "No",
            value: false,
            validations: []
        },
        {
            type: "textarea",
            id: "textarea",
            name: "fuel_description",
            placeholder: "Fuel Description",
            label: "Fuel Description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    fuel_sub_type_master: [
        {
            type: "text",
            name: "fuel_sub_type_name",
            placeholder: "Fuel sub type name",
            page_title: "Fuel Sub Type Master",
            label: "Fuel sub type",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Fuel sub type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "fuel_type_name",
            placeholder: "Select fuel type ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "fuel_type",
            path: "fuel_type_master",
            validations: [
                {
                    type: "required",
                    message: "Fuel type name is required"
                }
            ]
        },
        {
            type: "text",
            name: "co2_emission",
            placeholder: 'CO2 Emission',
            label: 'CO2 Emission',
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: `CO2 Emission  is required`
                },
                // {
                //     type: "matches",
                //     value: /^[0-9]+$/,
                //     message: "Please enter numbers only"
                // }
            ],
        },
    ],
    reporting_operation_mode_master: [
        {
            type: "text",
            name: "reporting_operation_mode_name",
            placeholder: "Reporting operation from last report",
            page_title: "Reporting Operation from last report",
            label: "Reporting operation from last report",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Reporting operation mode name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "reporting_type_name",
            label: "Applicable report ",
            placeholder: "Select applicable report",
            onChange: "",
            defaultValue: "",
            defaultValueName: "reporting_type",
            path: "reporting_type_master",
            validations: []
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "reporting_type",
            label: "Applicable report",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            options: [],
            validations: []
        },
    ],
    reporting_events_master: [
        {
            type: "text",
            name: "reporting_event_name",
            placeholder: "Report event name",
            page_title: "Reporting Events Master",
            label: "Report event name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Report event name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "alias_name",
            placeholder: "Alias name",
            label: "Alias name",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Alias Name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "is_noon_report",
            typeValue: "boolean",
            label: "Is this noon event",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether noon event or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "is_cii_adjustment_event",
            typeValue: "boolean",
            label: "Is this CII adjustment event",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether CII adjustment event or not"
                }
            ]
        },
        {
            type: "dynamic-select",
            name: "reporting_type_name",
            placeholder: "Select reporting type ",
            onChange: "",
            defaultValue: "",
            defaultValueName: "reporting_type",
            path: "reporting_type_master",
            validations: []
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "reporting_type",
            label: "Reporting type",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            options: [],
            validations: []
        },
        {
            type: "dynamic-select",
            name: "statusname",
            label: "Reporting event state",
            placeholder: "Select reporting event state",
            onChange: "",
            defaultValue: "",
            defaultValueName: "status",
            path: "reporting_event_state_master",
            validations: []
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "status",
            label: "Reporting event state",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            options: [],
            validations: []
        },
        {
            type: 'link',
            id: 'next_possible_events',
            name: 'next_possible_events',
            placeholder: 'Add next possible events for reporting events',
            popupPath: 'reporting_events_master',
            popupColTitle: 'Reporting events',
            popupType: 'events',
            popupTblField: 'reporting_event_name',
            popupTblState: 'status_shortname',
            popupTblType: 'reporting_type',
            options: [],
            validations: []
        }
    ],
    reporting_type_master: [
        {
            type: "text",
            name: "reporting_type_name",
            placeholder: "Report type name",
            page_title: "Reporting Type Master",
            label: "Report type name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Report type name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
    ],
    current_direction_master: [
        {
            type: "text",
            name: "current_direction_name",
            placeholder: "Current direction name",
            page_title: "Current Direction Master",
            label: "Current direction name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Current direction name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "current_direction_short_name",
            placeholder: "Current direction short name",
            label: "Current direction short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Current direction short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{1,25}$/,
                    message: "Please enter atleast 1 and upto 25 block letters only"
                }
            ],
        },
    ],
    machinery_list_master: [
        {
            type: "text",
            name: "machinery_name",
            placeholder: "Machinery name",
            page_title: "Machinery List Master",
            label: "Machinery name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Machinery name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "machinery_short_name",
            placeholder: "Machinery short name",
            label: "Machinery short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Machinery short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "machinery_description",
            placeholder: "Machinery description",
            label: "Machinery description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    vessel_machinery_list: [
        {
            type: "text",
            name: "vessel_machinery_name",
            placeholder: "Vessel machinery name",
            page_title: "Vessel Machinery List",
            label: "Vessel machinery name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel machinery name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "machinery_name",
            placeholder: "Select machinery name ",
            label: "Machinery name",
            onChange: "",
            defaultValue: "",
            defaultValueName: "machinery",
            path: "machinery_list_master",
            validations: []
        },
        {
            type: "hidden",
            id: "select_field_name",
            name: "machinery",
            label: "Machinery name",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            options: [],
            validations: []
        },
        {
            type: "checkbox",
            name: "daily_machine_running_hours_required",
            typeValue: "boolean",
            label: "Daily machine running hours required?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether daily machine running per hour required or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "sfoc_required",
            typeValue: "boolean",
            label: "SFOC?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            class: "switch-label",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether SFOC or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "egcs_in_use",
            typeValue: "boolean",
            label: "Is EGCS in use?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            class: "switch-label",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether EGCS is in use or not"
                }
            ]
        },
        {
            type: "checkbox",
            name: "scr_egr_in_use",
            typeValue: "boolean",
            label: "Is SCR / EGR in use?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            class: "switch-label",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether SCR / EGR is in use or not"
                }
            ]
        },
    ],
    sensor_list_master: [
        {
            type: "text",
            name: "sensor_name",
            placeholder: "Sensor name",
            page_title: "Sensor List Master",
            label: "Sensor name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Sensor name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "sensor_short_name",
            placeholder: "Sensor short name",
            label: "Sensor short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Sensor short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "sensor_description",
            placeholder: "Sensor description",
            label: "Sensor description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    lube_oil_list_master: [
        {
            type: "text",
            name: "lube_oil_name",
            placeholder: "Lube oil name",
            page_title: "Lube Oil List Master",
            label: "Lube oil name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Lube oil name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "lube_oil_short_name",
            placeholder: "Lube oil short name",
            label: "Lube oil short name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Lube oil short name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "lube_oil_description",
            placeholder: "Lube oil description",
            label: "Lube oil description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"
                }
            ],
        },
    ],
    douglas_sea_scale_master: [
        {
            type: "text",
            name: "douglas_sea_scale",
            placeholder: "Douglas sea scale",
            page_title: "Douglas Sea Scale Master",
            label: "Douglas sea scale",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Douglas sea scale is required"
                },
                {
                    type: "matches",
                    value: /^([0-9]|1[9])$/,
                    message: "Please enter values between 0 - 9 only"
                }
            ],
        },
        {
            type: "text",
            name: "douglas_sea_scale_condition",
            placeholder: "Sea scale condition",
            label: "Sea scale condition",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Sea scale condition is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }

            ],
        },
        {
            type: "text",
            name: "minimum_wave_height",
            placeholder: "Minimum wave height",
            label: "Minimum wave height",
            table_columns: true,
            table_columns_sequence: 3,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Minimum wave height is required"
                },
                {
                    type: "matches",
                    value: /^\d{0,3}(\.\d{0,2})?$/,
                    message: "Please enter upto 3 digits before and upto 2 digits after decimal point"
                }
            ],
        },
        {
            type: "text",
            name: "maximum_wave_height",
            placeholder: "Maximum wave height",
            label: "Maximum wave height",
            table_columns: true,
            table_columns_sequence: 3,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Maximum wave height is required"
                },
                {
                    type: "matches",
                    value: /^\d{0,3}(\.\d{0,2})?$/,
                    message: "Please enter upto 3 digits before and upto 2 digits after decimal point"
                }
            ],
        },
    ],
    strait_canal_transit_list_master: [
        {
            type: "text",
            name: "strait_canal_transit",
            placeholder: "Strait canal transit name",
            label: "Strait canal transit name",
            page_title: "Starit Canal Transit List Master",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Strait canal transit name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
    ],
    cii_adjustment_events_master: [
        {
            type: "text",
            name: "adjustment_event_name",
            placeholder: "Adjustment event name",
            page_title: "Adjustment Events Master",
            label: "Adjustment Event name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Adjustment event name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z- ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "alias_name",
            placeholder: "Alias name",
            label: "Alias name",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Alias Name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "description",
            label: "Adjustment description",
            placeholder: "Adjustment description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
    ],

    vessel_owner_master: [
        {
            type: "text",
            name: "company_name",
            placeholder: "Vessel owner name",
            page_title: "Vessel Owner Master",
            label: "Vessel owner name",
            table_columns: true,
            table_columns_sequence: 1,
            value: "",
            validations: [
                {
                    type: "required",
                    message: "Vessel name is required"
                },
                {
                    type: "matches",
                    value: /^[A-Za-z-. ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "dynamic-select",
            name: "country_name",
            placeholder: "Select country ",
            label: "Country of registration",
            onChange: "",
            defaultValue: "",
            defaultValueName: "country",
            path: "country_master",
            validations: []
        },
        {
            type: "text",
            name: "vessel_owner_identification_number",
            placeholder: "Vessel owner identification number",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "company_IMO_number",
            placeholder: "Vessel owner IMO number",
            label: "Vessel owner IMO number",
            table_columns: true,
            table_columns_sequence: 2,
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]{1,11}$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "mobile",
            placeholder: "Mobile number",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]{1,10}$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "phone",
            placeholder: "Phone number",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]{10}$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "email",
            name: "email",
            placeholder: "Email id",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                }
            ],
        },
        {
            type: "text",
            name: "fax",
            placeholder: "Fax",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]{1,14}$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "textarea",
            name: "company_address",
            placeholder: "Vessel owner address",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
        {
            type: "textarea",
            name: "company_description",
            placeholder: "Description",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
    ],

    cargo_control_room: [
        {
            type: "checkbox",
            page_title: "Cargo Control Room",
            name: "is_ship_fitted_with_a_cargo_control_room",
            typeValue: "boolean",
            label: "Is ship fitted with a cargo control room?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether ship is fitted with a cargo control room"
                }
            ]
        },
        {
            type: "checkbox",
            name: "can_tank_innage_or_ullage_be_read_from_the_ccr",
            typeValue: "boolean",
            label: "Can tank ullage be read from the CCR?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    type: "required",
                    message: "Select whether EU port or not"
                }
            ]
        },
        {
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel ",
            onChange: "",
            //  defaultValue: "",
            //  defaultValueName: "vessel_name",
            path: "vessel_name",
            validations: []
        },
    ],

    Ballast_information_of_vessel: [
        {
            page_title: "Ballast Information",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel ",
            onChange: "",
            //  defaultValue: "",
            //  defaultValueName: "vessel_name",
            path: "vessel_name",
            validations: []
        },
        {
            type: "text",
            name: "number_of_ballast_pump",
            label: "Number of ballast pump",
            placeholder: "Number of ballast pump",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_ballast_pump",
            placeholder: "Type of ballast pump",
            label: "Type of ballast pump",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "capacity_of_ballast_pump",
            label: "Capacity of ballast pump",
            placeholder: "Capacity of ballast pump",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "ballast_pump_at_what_head",
            label: "Ballast pump",
            placeholder: "Ballast pump",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "number_of_ballast_eductor",
            label: "Number of ballast educator",
            placeholder: "Number of ballast educator",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_ballast_eductor",
            placeholder: "Type of ballast eductor",
            label: "Type of ballast eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "text",
            name: "capacity_of_ballast_educator",
            label: "Capacity of ballast eductor",
            placeholder: "Capacity of ballast eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "ballast_educator_at_what_head",
            label: "Ballast eductor",
            placeholder: "Ballast eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(?:[0-9]|[1-5][0-9]|6[0-4])$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    vessel_coating_information: [
        {
            page_title: "Vessel Coating Information",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel ",
            onChange: "",
            //  defaultValue: "",
            //  defaultValueName: "vessel_name",
            path: "vessel_name",
            validations: []
        },
        {
            type: "checkbox",
            name: "is_cargo_tank_coated",
            typeValue: "boolean",
            label: "Is cargo tank coated?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "text",
            name: "cargo_tank_coating_type",
            label: "Cargo tank coating type",
            placeholder: "Cargo tank coating type",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "text",
            name: "cargo_tank_coating_to_what_extent",
            label: "Cargo tank coating to what extent",
            placeholder: "Cargo tank coating to what extent",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "is_cargo_tank_anodes",
            typeValue: "boolean",
            label: "Is cargo tank anodes?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "checkbox",
            name: "ballast_tank_coated",
            typeValue: "boolean",
            label: "Ballast tank coated?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "text",
            name: "ballast_tank_coating_type",
            label: "Ballast tank coating type",
            placeholder: "Ballast tank coating type",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "text",
            name: "ballast_tank_coating_to_what_extent",
            label: "Ballast tank coating to what extent",
            placeholder: "Ballast tank coating to what extent",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "ballast_tank_anodes",
            typeValue: "boolean",
            label: "Ballast tank anodes?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "checkbox",
            name: "slop_tank_coated",
            typeValue: "boolean",
            label: "Slop tank coated?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "text",
            name: "slop_tank_coating_type",
            label: "Slop tank coating type",
            placeholder: "Slope tank coating type",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Z]{2,25}$/,
                    message: "Please enter atleast 2 and upto 25 block letters only"
                }
            ],
        },
        {
            type: "text",
            name: "slop_tank_coating_to_what_extent",
            label: "Slop tank coating to what extent",
            placeholder: "Slop tank coating to what extent",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Please enter upto 50 alphabets only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "slop_tank_anodes",
            typeValue: "boolean",
            label: "Slop tank anodes?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
    ],

    vessel_for_usa_calls: [
        {
            page_title: "Vessel for USA Calls",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            //  defaultValue: "",
            //  defaultValueName: "vessel_name",
            path: "vessel_name",
            validations: []
        },
        {
            type: "checkbox",
            name: "has_the_vessel_operator_submitted_a_vessel_spill_response_plan_to_the_US_coast_gaurd_which_has_been_approved_by_offcial_USCG_letter",
            typeValue: "boolean",
            label: "Has the vessel operator submitted a vessel spill response plan to the US Coast Gaurd which has been approved by official USCG letter?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "checkbox",
            name: "qualified_individual",
            typeValue: "boolean",
            label: "Qualified Individual (QI)- FS",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "checkbox",
            name: "oil_spill_response_organization",
            typeValue: "boolean",
            label: "Oil spill response organization (OSRO)- FS",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
        {
            type: "checkbox",
            name: "salvage_and_marine_firefighting_services",
            typeValue: "boolean",
            label: "Salvage and marine firefighting services (SMFF)- FS",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                }
            ]
        },
    ],

    anchors_towing_system: [
        {
            page_title: "Anchors/Emergency Towing System",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "number_of_shackles_on_port",
            label: "Number of shackles on port",
            placeholder: "Number of shackles on port",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "number_of_starboard_cable",
            label: "Number of starboard cable",
            placeholder: "Number of starboard cable",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_emergency_towing_system_forward",
            label: "Type of emergency towing system forward",
            placeholder: "Type of emergency towing system forward",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9- ]{1,50}$/
                }
            ],
        },
        {
            type: "text-unit",
            name: "swl_of_emergency_towing_system_forward",
            placeholder: "SWL of emergency towing system forward",
            label: "SWL of emergency towing system forward",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_emergency_towing_system_aft",
            label: "Type of emergency towing system aft",
            placeholder: "Type of emergency towing system aft",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9- ]{1,50}$/
                }
            ],
        },
        {
            type: "text-unit",
            name: "swl_of_emergency_towing_system_aft",
            placeholder: "SWL of emergency towing system aft",
            label: "SWL of emergency towing system aft",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
    ],

    escort_tug: [
        {
            page_title: "Escort Tug",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_name",
            validations: []
        },
        {
            type: "text",
            name: "size_of_closed_chock",
            label: "Size of closed chock",
            placeholder: "Size of closed chock",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "swl_of_closed_chock",
            label: "SWL of closed chock",
            placeholder: "SWL of closed chock",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "fairleads_of_enclosed_type_on_stern",
            placeholder: "Fairleads of enclosed type on stern",
            label: "Fairleads of enclosed type on stern",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
        {
            type: "text-unit",
            name: "swl_of_bollard_on_poop_deck_suitable_for_escort_tug",
            placeholder: "SWL of bollard on poop deck suitable for escort tug",
            label: "SWL of bollard on poop deck suitable for escort tug",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
        {
            type: "text-unit",
            name: "swl_of_bollard_on_poop_deck_suitable_for_mooring",
            placeholder: "SWL of bollard on poop deck suitable for mooring",
            label: "SWL of bollard on poop deck suitable for mooring",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{0,4}(\.\d{0,2})?$/,
                    message: "Please enter upto 4 numbers before and 2 numbers after the decimal point"
                }
            ],
        },
    ],

    mooring_wire_on_drum: [
        {
            page_title: "Mooring Wire on Drum",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "forecastle_number",
            label: "Forecastle number",
            placeholder: "Forecastle number",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_diameter",
            label: "Forecastle diameter",
            placeholder: "Forecastle diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_material",
            label: "Forecastle material",
            placeholder: "Forecastle material",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_length",
            label: "Forecastle length",
            placeholder: "Forecastle length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_breaking_strength",
            placeholder: "Forecastle breaking strength",
            label: "Forecastle breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number",
            label: "Main deck fwd number",
            placeholder: "Main deck fwd number",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_diameter",
            label: "Main deck fwd diameter",
            placeholder: "Main deck fwd diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_material",
            label: "Main deck fwd material",
            placeholder: "Main deck fwd material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_length",
            label: "Main deck fwd length",
            placeholder: "Main deck fwd length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_breaking_strength",
            placeholder: "Main deck fwd breaking strength",
            label: "Main deck fwd breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number",
            label: "Main deck aft number",
            placeholder: "Main deck aft number",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_diameter",
            label: "Main deck aft diameter",
            placeholder: "Main deck aft diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_material",
            label: "Main deck aft material",
            placeholder: "Main deck aft material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_length",
            label: "Main deck aft length",
            placeholder: "Main deck aft length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_breaking_strength",
            placeholder: "Main deck aft breaking strength",
            label: "Main deck aft breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number",
            label: "Poop deck number",
            placeholder: "Poop deck number",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_diameter",
            label: "Poop_deck diameter",
            placeholder: "Poop deck diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_material",
            label: "Poop deck material",
            placeholder: "Poop deck material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_length",
            label: "Poop deck length",
            placeholder: "Poop deck length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_breaking_strength",
            placeholder: "Poop deck breaking strength",
            label: "Poop deck breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    mooring_wire_tail: [
        {
            page_title: "Mooring Wire Tails",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "forecastle_number",
            label: "Forecastle number",
            placeholder: "Forecastle number",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_diameter",
            label: "Forecastle diameter",
            placeholder: "Forecastle diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_material",
            label: "Forecastle material",
            placeholder: "Forecastle material",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_length",
            label: "Forecastle length",
            placeholder: "Forecastle length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_breaking_strength",
            placeholder: "Forecastle breaking strength",
            label: "Forecastle breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number",
            label: "Main deck fwd number",
            placeholder: "Main deck fwd number",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_diameter",
            label: "Main deck fwd diameter",
            placeholder: "Main deck fwd diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_material",
            label: "Main deck fwd material",
            placeholder: "Main deck fwd material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_length",
            label: "Main deck fwd length",
            placeholder: "Main deck fwd length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_breaking_strength",
            placeholder: "Main deck fwd breaking strength",
            label: "Main deck fwd breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number",
            label: "Main deck aft number",
            placeholder: "Main deck aft number",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_diameter",
            label: "Main deck aft diameter",
            placeholder: "Main deck aft diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_material",
            label: "Main deck aft material",
            placeholder: "Main deck aft material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_length",
            label: "Main deck aft length",
            placeholder: "Main deck aft length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_breaking_strength",
            placeholder: "Main deck aft breaking strength",
            label: "Main deck aft breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number",
            label: "Poop deck number",
            placeholder: "Poop deck number",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_diameter",
            label: "Poop_deck diameter",
            placeholder: "Poop deck diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_material",
            label: "Poop deck material",
            placeholder: "Poop deck material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_length",
            label: "Poop deck length",
            placeholder: "Poop deck length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_breaking_strength",
            placeholder: "Poop deck breaking strength",
            label: "Poop deck breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    mooring_ropes_on_drum: [
        {
            page_title: "Mooring Ropes on Drums",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "forecastle_number",
            label: "Forecastle number",
            placeholder: "Forecastle number",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_diameter",
            label: "Forecastle diameter",
            placeholder: "Forecastle diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_material",
            label: "Forecastle material",
            placeholder: "Forecastle material",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_length",
            label: "Forecastle length",
            placeholder: "Forecastle length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_breaking_strength",
            placeholder: "Forecastle breaking strength",
            label: "Forecastle breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number",
            label: "Main deck fwd number",
            placeholder: "Main deck fwd number",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_diameter",
            label: "Main deck fwd diameter",
            placeholder: "Main deck fwd diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_material",
            label: "Main deck fwd material",
            placeholder: "Main deck fwd material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_length",
            label: "Main deck fwd length",
            placeholder: "Main deck fwd length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_breaking_strength",
            placeholder: "Main deck fwd breaking strength",
            label: "Main deck fwd breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number",
            label: "Main deck aft number",
            placeholder: "Main deck aft number",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_diameter",
            label: "Main deck aft diameter",
            placeholder: "Main deck aft diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_material",
            label: "Main deck aft material",
            placeholder: "Main deck aft material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_length",
            label: "Main deck aft length",
            placeholder: "Main deck aft length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_breaking_strength",
            placeholder: "Main deck aft breaking strength",
            label: "Main deck aft breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number",
            label: "Poop deck number",
            placeholder: "Poop deck number",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_diameter",
            label: "Poop_deck diameter",
            placeholder: "Poop deck diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_material",
            label: "Poop deck material",
            placeholder: "Poop deck material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_length",
            label: "Poop deck length",
            placeholder: "Poop deck length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_breaking_strength",
            placeholder: "Poop deck breaking strength",
            label: "Poop deck breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    mooring_other_line: [
        {
            page_title: "Mooring Other Lines",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "forecastle_number",
            label: "Forecastle number",
            placeholder: "Forecastle number",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_diameter",
            label: "Forecastle diameter",
            placeholder: "Forecastle diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_material",
            label: "Forecastle material",
            placeholder: "Forecastle material",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_length",
            label: "Forecastle length",
            placeholder: "Forecastle length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_breaking_strength",
            placeholder: "Forecastle breaking strength",
            label: "Forecastle breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number",
            label: "Main deck fwd number",
            placeholder: "Main deck fwd number",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_diameter",
            label: "Main deck fwd diameter",
            placeholder: "Main deck fwd diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_material",
            label: "Main deck fwd material",
            placeholder: "Main deck fwd material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_length",
            label: "Main deck fwd length",
            placeholder: "Main deck fwd length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_breaking_strength",
            placeholder: "Main deck fwd breaking strength",
            label: "Main deck fwd breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number",
            label: "Main deck aft number",
            placeholder: "Main deck aft number",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_diameter",
            label: "Main deck aft diameter",
            placeholder: "Main deck aft diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_material",
            label: "Main deck aft material",
            placeholder: "Main deck aft material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_length",
            label: "Main deck aft length",
            placeholder: "Main deck aft length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_breaking_strength",
            placeholder: "Main deck aft breaking strength",
            label: "Main deck aft breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number",
            label: "Poop deck number",
            placeholder: "Poop deck number",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_diameter",
            label: "Poop_deck diameter",
            placeholder: "Poop deck diameter",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_material",
            label: "Poop deck material",
            placeholder: "Poop deck material",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_length",
            label: "Poop deck length",
            placeholder: "Poop deck length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_breaking_strength",
            placeholder: "Poop deck breaking strength",
            label: "Poop deck breaking strength",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    mooring_winche: [
        {
            page_title: "Mooring Winches",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "forecastle_number",
            label: "Forecastle number",
            placeholder: "Forecastle number",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_number_of_drums",
            label: "Forecastle number of drums",
            placeholder: "Forecastle number of drums",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_motive_power",
            label: "Forecastle motive power",
            placeholder: "Forecastle motive power",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_brake_capacity",
            label: "Forecastle brake capacity",
            placeholder: "Forecastle brake capacity",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number",
            label: "Main deck fwd number",
            placeholder: "Main deck fwd number",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_number_of_drums",
            label: "Main deck fwd number of drums",
            placeholder: "Main deck number of drums",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_motive_power",
            label: "Main deck fwd motive power",
            placeholder: "Main deck fwd motive power",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_brake_capacity",
            label: "Main deck fwd brake capacity",
            placeholder: "Main deck fwd brake capacity",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number",
            label: "Main deck aft number",
            placeholder: "Main deck aft number",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number_of_drums",
            label: "Main deck aft number of drums",
            placeholder: "Main deck aft number of drums",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_motive_power",
            label: "Main deck aft motive power",
            placeholder: "Main deck aft motive power",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_break_capacity",
            label: "Main deck aft break capacity",
            placeholder: "Main deck aft break capacity",
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number",
            label: "Poop deck number",
            placeholder: "Poop deck number",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_number_of_drums",
            label: "Poop_deck number of drums",
            placeholder: "Poop deck number of drums",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_motive_power",
            label: "Poop deck motive power",
            placeholder: "Poop deck motive power",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_break_capacity",
            label: "Poop deck break capacity",
            placeholder: "Poop deck break capacity",
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "winches_break_type",
            placeholder: "Winches break type",
            label: "Winches break type",
            table_columns: false,
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
    ],

    bitts_closed_chock: [
        {
            page_title: "Mooring Wire Tails",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text-unit",
            name: "forecastle_number_of_bitts",
            label: "Forecastle number of bitts",
            placeholder: "Forecastle number of bitts",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text",
            name: "forecastle_swl_bitts",
            label: "Forecastle swl_bitts",
            placeholder: "Forecastle swl_bitts",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z& ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_number_of_closed_chocks",
            label: "Forecastle number of closed chocks",
            placeholder: "Forecastle number of closed chocks",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "forecastle_SWL_closed_chocks",
            placeholder: "Forecastle SWL closed chocks",
            label: "Forecastle SWL closed chocks",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_fwd_number_of_bitts",
            label: "Main deck fwd number of bitts",
            placeholder: "Main deck fwd number of bitts",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_SWL_bitts",
            label: "Main deck fwd SWL bitts",
            placeholder: "Main deck fwd SWL bitts",
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_number_of_closed_chocks",
            label: "Main deck fwd number of closed chocks",
            placeholder: "Main deck fwd number of closed chocks",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_fwd_SWL_closed_chocks",
            placeholder: "Main deck fwd SWL closed chocks",
            label: "Main deck fwd SWL closed chocks",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "main_deck_aft_number_of_bitts",
            label: "Main deck aft number of bitts",
            placeholder: "Main deck aft number of bitts",
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_SWL_bitts",
            label: "Main deck aft diameter SWL bitts",
            placeholder: "Main deck aft SWL bitts",
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_number_of_closed_chocks",
            label: "Main deck aft number of closed chocks",
            placeholder: "Main deck aft number of closed chocks",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "main_deck_aft_SWL_closed_chocks",
            placeholder: "Main deck aft SWL closed chocks",
            label: "Main deck aft SWL closed chocks",
            table_columns: false,
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "poop_deck_number_of_bitts",
            label: "Poop deck number of bitts",
            placeholder: "Poop deck number of bitts",
            value: "",
            table_columns: true,
            table_columns_sequence: 4,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_SWL_bitts",
            label: "Poop_deck SWL bitts",
            placeholder: "Poop deck SWL bitts",
            unit: "mm",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_number_of_closed_chocks",
            label: "Poop deck number of closed chocks",
            placeholder: "Poop deck number of closed chocks",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "poop_deck_SWL_closed_chocks",
            placeholder: "Poop deck SWL closed chocks",
            label: "Poop deck SWL closed chocks",
            unit: "mt",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    cargo_pump: [
        {
            page_title: "Cargo Pumps",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "how_many_cp_can_be_run_at_full_capacity",
            label: "How many cargo pump can be run simultaneously at full capacity?",
            placeholder: "How many cargo pump can be run simultaneously at full capacity?",
            value: "",
            validations: [

                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "number_of_cargo_pumps",
            label: "Number of Cargo Pump",
            placeholder: "Number of Cargo Pump",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [

                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_cargo_pump",
            label: "Type of cargo pump",
            placeholder: "Type of cargo pump",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                    message: "Only alphabets are allowed"
                }
            ],
        },
        {
            type: "text-unit",
            name: "cargo_pump_capacity",
            placeholder: "Cargo pump capacity",
            label: "Cargo pump capacity",
            unit: ['M', <sup>3</sup>, '/HR'],
            value: "",
            table_columns: true,
            table_columns_sequence: 3,
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "cargo_pump_at_what_head",
            placeholder: "Cargo pump at what head",
            label: "Cargo pump at what head",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "number_of_cargo_eductor",
            placeholder: "Number of cargo eductor",
            label: "Number of cargo eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_cargo_eductor",
            placeholder: "Type of cargo eductor",
            label: "Type of cargo eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9 ]+$/,
                    message: "Please enter type of cargo eductor"
                }
            ],
        },
        {
            type: "text",
            name: "capacity_of_cargo_eductor",
            placeholder: "Capacity of cargo eductor",
            label: "Capacity of cargo eductor",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9 ]+$/,
                    message: "Please enter type of cargo eductor"
                }
            ],
        },
        {
            type: "text-unit",
            name: "cargo_eductor_at_what_head",
            placeholder: "Cargo eductor at what head",
            label: "Cargo eductor at what head",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "number_of_stripping",
            placeholder: "Number of stripping",
            label: "Number of stripping",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text",
            name: "type_of_stripping",
            placeholder: "Type of stripping",
            label: "Type of stripping",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9 ]+$/,
                    message: "Please enter type of stripping"
                }
            ],
        },
        {
            type: "text",
            name: "capacity_of_stripping",
            placeholder: "Capacity of stripping",
            label: "Capacity of stripping",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z0-9 ]+$/
                }
            ],
        },
        {
            type: "text-unit",
            name: "cargo_stripping_at_what_head",
            placeholder: "Stripping at what head",
            label: "Stripping at what head",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "emergency_portable_cargo_pump_provided",
            typeValue: "boolean",
            label: "Emergency portable cargo pump provided ?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
            ]
        },
    ],

    common_contacts: [
        {
            page_title: "Common Contacts",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "name",
            placeholder: "Name",
            label: "Name",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z ]{1,50}$/,
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "address",
            label: "Address",
            placeholder: "Address",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
        {
            type: "text",
            name: "phone",
            placeholder: "Phone number",
            label: "Phone number",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\+\d{10}$/,
                }
            ],
        },
        {
            type: "text",
            name: "fax",
            placeholder: "Fax",
            label: "Fax",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[+\d -]{7,15}$/,
                }
            ],
        },
        {
            type: "text",
            name: "telex",
            placeholder: "Telex",
            label: "Telex",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[+\d -]{7,17}$/,
                }
            ],
        },
        {
            type: "email",
            name: "email",
            placeholder: "Email",
            label: "Email",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                }
            ],
        },
        {
            type: "url",
            name: "website",
            placeholder: "Website",
            label: "Website",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^(http|https):\/\/([\w.]+\.[a-z]{2,63}(:\d{1,5})?\/.*)$/,
                }

            ],
        },
    ],

    vessel_build_information: [
        {
            page_title: "Vessel Build Information",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "date",
            name: "keel_laid",
            placeholder: "Keel laid date",
            label: "Keel laid date",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "date",
            name: "launched",
            placeholder: "Launched date",
            label: "Launched date",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "date",
            name: "delivered",
            placeholder: "Delivered date",
            label: "Delivered date",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "textarea",
            id: "textarea",
            name: "ship_yard",
            label: "Ship yard",
            placeholder: "Ship yard",
            value: "",
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
    ],

    vessel_dimension: [
        {
            page_title: "Vessel Dimension",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text-unit",
            name: "length_overall",
            label: "Length overall",
            placeholder: "Length overall",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "length_between_perpendicular",
            label: "Length between perpendiculars",
            placeholder: "Length between perpendiculars",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "extreme_breadth",
            label: "Extreme breadth",
            placeholder: "Extreme breadth(Beam)",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "Modulded_depth",
            label: "Modulded depth",
            placeholder: "Modulded depth",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "keel_to_masthead",
            label: "Keel to masthead",
            placeholder: "Keel to masthead",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "keel_to_masthead_in_collapsed_condition",
            label: "Keel to masthead in collapsed condition",
            placeholder: "Keel to masthead in collapsed condition",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "Distance_bridge_front_to_center_of_manifold",
            label: "Distance bridge front to center of manifold",
            placeholder: "Distance bridge front to center of manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "bow_to_center_of_manifold",
            label: "Bow to center of manifold",
            placeholder: "Bow to center of manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "stern_to_center_manifold",
            label: "Stern to center of manifold",
            placeholder: "Stern to center of manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_Lightship_forward_to_midpoint_manifold",
            label: "Distance of lightship forward to midpoint manifold",
            placeholder: "Distance of lightship forward to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_normal_ballast_forward_to_midpoint_manifold",
            label: "Distance of normal ballast forward to midpoint manifold",
            placeholder: "Distance of normal ballast forward to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_summer_Dwt_forward_to_midpoint_manifold",
            label: "Distance of summer Swt forward to midpoint manifold",
            placeholder: "Distance of summer Swt forward to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_Lightship_Aft_to_midpoint_manifold",
            label: "Distance of lightship aft to midpoint manifold",
            placeholder: "Distance of lightship aft to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_normal_ballast_Aft_to_midpoint_manifold",
            label: "Distance of normal ballast aft to midpoint manifold",
            placeholder: "Distance of normal ballast aft to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_summer_Dwt_Aft_to_midpoint_manifold",
            label: "Distance of summer Dwt aft to midpoint manifold",
            placeholder: "Distance of summer Dwt aft to midpoint manifold",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_Lightship_parallel_body_length",
            label: "Distance of lightship parallel body length",
            placeholder: "Distance of lightship parallel body length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_normal_ballast_parallel_body_length",
            label: "Distance of normal ballast parallel body length",
            placeholder: "Distance of normal ballast parallel body length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
        {
            type: "text-unit",
            name: "distance_of_summer_Dwt_parallel_body_length",
            label: "Distance of summer Dwt parallel body length",
            placeholder: "Distance of summer Dwt parallel body length",
            unit: "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ],
        },
    ],

    certificates: [
        {
            page_title: "Vessel Certificates",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "text",
            name: "name_of_certificate",
            label: "Certificate name",
            placeholder: "Certificate name",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z()0-9 ]{1,50}$/,
                    message: "Please enter upto 100 alphabets only"
                }
            ],
        },
        {
            type: "date",
            name: "date_of_issued_certificate",
            placeholder: "Certificate issued date",
            label: "Certificate issued date",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "date",
            name: "last_annual_of_certificate",
            placeholder: "Last annual date of certificate",
            label: "Last annual date of certificate",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "date",
            name: "last_intermediate_of_certificate",
            placeholder: "Last intermediate of certificate",
            label: "Last intermediate of certificate",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
        {
            type: "date",
            name: "expiry_date_of_certificate",
            placeholder: "Certificate expiry date",
            label: "Certificate expiry date",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^\d{4}-\d{1,2}-\d{1,2}$/,
                }
            ],
        },
    ],

    lifting_equipment_or_gangway: [
        {
            page_title: "Vessel's Lifting Equipment/Gangway",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "textarea",
            name: "derrick_description",
            label: "Derrick description",
            placeholder: "Derrick description",
            value: "",
            table_columns: true,
            table_columns_sequence: 1,
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
        {
            type: "textarea",
            name: "crane_description",
            label: "Crane description",
            placeholder: "Crane description",
            value: "",
            table_columns: true,
            table_columns_sequence: 2,
            validations: [
                {
                    type: "maxLength",
                    value: 200,
                    message: "Please enter upto 200 alphabets/numbers only"

                }
            ],
        },
        {
            type: "text",
            name: "accomodation_ladder_direction",
            label: "Accomodation ladder direction",
            placeholder: "Accomodation ladder direction",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[A-Za-z()0-9 ]{1,50}$/,
                    message: "Please enter upto 100 alphabets only"
                }
            ],
        },
        {
            type: "checkbox",
            name: "does_vessel_have_a_portable_gangway",
            typeValue: "boolean",
            label: "Does vessel have a portable gangway?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
                {
                    message: "Select whether vessel have a portable gangway or not"
                }
            ]
        },
        {
            type: "text-unit",
            name: "portable_gangway_length",
            label: "Portable gangway length",
            "placeholder": "Portable gangway length",
            "unit": "m",
            value: "",
            validations: [
                {
                    type: "matches",
                    value: /^[0-9.]+$/,
                    message: "Please enter numbers only"
                }
            ]
        }
    ],

    inert_gas_and_crude_oil_washing: [
        {
            page_title: "Vessel's Inert Gas and Crude Oil Washing",
            type: "dynamic-select",
            name: "vessel_name",
            placeholder: "Select Vessel",
            onChange: "",
            defaultValue: "",
            defaultValueName: "vessel_name",
            path: "vessel_master",
            validations: []
        },
        {
            type: "checkbox",
            name: "is_inert_gas_system_fitted",
            typeValue: "boolean",
            label: "Is inert gas system fitted?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
            ]
        },
        {
            type: "checkbox",
            name: "is_inert_gas_system_operational",
            typeValue: "boolean",
            label: "Is inert gas system operational?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
            ]
        },
        {
            type: "checkbox",
            name: "is_crude_oil_washing_installation_fitted",
            typeValue: "boolean",
            label: "Is crude oil washing installation fitted?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
            ]
        },
        {
            type: "checkbox",
            name: "is_crude_oil_washing_installation_operational",
            typeValue: "boolean",
            label: "IGS crude oil washing installation operational?",
            defaultChecked: null,
            on: "Yes",
            off: "No",
            value: false,
            validations: [
            ]
        },
        {
            type: "select",
            name: "IGS_supplied_by",
            label: "IGS supplied by",
            value: "",
            options: [
                { desc: "Fuel gas", value: "Fuel gas" },
                { desc: "Inert gas generator", value: "Inert gas generator" },
                { desc: "Nitrogen", value: "Nitrogen" },
                //  { desc: "Applicable flow rate", value: "applicable_flow_rate", visible: { field: "IGS_supplied_by", value: "Nitrogen" } }
            ],
            validations: [
                /*  {
                      type: "required",
                      message: "Please enter the applicable flow rate for nitrogen.",
                      if: {
                          field: "IGS_supplied_by",
                          value: "Nitrogen"
                      }
                  } */
            ]
        },
    ]


}

export default Forms;

